export const AudRestrictions = {
	"2025-01-02": {
		high: 60.438,
		low: 39.736
	},
	"2025-01-03": {
		high: 60.084,
		low: 39.528
	},
	"2025-01-06": {
		high: 60.294,
		low: 39.4
	},
	"2025-01-07": {
		high: 60.312,
		low: 39.928
	},
	"2025-01-08": {
		high: 61.116,
		low: 39.424
	},
	"2025-01-09": {
		high: 60.54,
		low: 39.812
	},
	"2025-01-10": {
		high: 60.792,
		low: 39.816
	},
	"2025-01-13": {
		high: 60.54,
		low: 39.328
	},
	"2025-01-14": {
		high: 61.428,
		low: 40
	},
	"2025-01-15": {
		high: 62.304,
		low: 40.992
	},
	"2025-01-16": {
		high: 65.472,
		low: 42
	},
	"2025-01-17": {
		high: 66.072,
		low: 42.84
	},
	"2025-01-20": {
		high: 65.712,
		low: 43.344
	},
	"2025-01-21": {
		high: 66.216,
		low: 43.512
	},
	"2025-01-22": {
		high: 66.036,
		low: 43.176
	},
	"2025-01-23": {
		high: 65.544,
		low: 43.04
	},
	"2025-01-24": {
		high: 65.616,
		low: 42.36
	},
	"2025-01-28": {
		high: 65.484,
		low: 42.48
	},
	"2025-01-29": {
		high: 64.98,
		low: 42.72
	},
	"2025-01-30": {
		high: 65.016,
		low: 42.608
	},
	"2025-01-31": {
		high: 66.108,
		low: 43.36
	},
	"2025-02-03": {
		high: 63.396,
		low: 41.32
	},
	"2025-02-04": {
		high: 63.996,
		low: 41.6
	},
	"2025-02-05": {
		high: 63.252,
		low: 41.56
	},
	"2025-02-06": {
		high: 64.896,
		low: 42.528
	},
	"2025-02-07": {
		high: 65.268,
		low: 43.04
	},
	"2025-02-10": {
		high: 64.344,
		low: 42.544
	},
	"2025-02-11": {
		high: 64.272,
		low: 42.424
	},
	"2025-02-12": {
		high: 64.08,
		low: 41.812
	},
	"2025-02-13": {
		high: 63.708,
		low: 40.832
	},
	"2025-02-14": {
		high: 62.46,
		low: 40.84
	},
	"2025-02-17": {
		high: 61.416,
		low: 40
	},
	"2025-02-18": {
		high: 61.248,
		low: 39.92
	},
	"2025-02-19": {
		high: 64.068,
		low: 40.28
	},
	"2025-02-20": {
		high: 61.716,
		low: 40.192
	},
	"2025-02-21": {
		high: 61.896,
		low: 40.44
	},
	"2025-02-24": {
		high: 61.668,
		low: 39.24
	},
	"2025-02-25": {
		high: 59.34,
		low: 38.936
	},
	"2025-02-26": {
		high: 61.92,
		low: 39.704
	},
	"2025-02-27": {
		high: 62.856,
		low: 40.544
	},
	"2025-02-28": {
		high: 61.86,
		low: 40.296
	},
	"2025-03-03": {
		high: 62.064,
		low: 40.496
	},
	"2025-03-04": {
		high: 61.332,
		low: 40.272
	},
	"2025-03-05": {
		high: 61.404,
		low: 40.056
	},
	"2025-03-06": {
		high: 61.716,
		low: 40.488
	},
	"2025-03-07": {
		high: 61.956,
		low: 40.4
	},
	"2025-03-10": {
		high: 61.368,
		low: 40.2
	},
	"2025-03-11": {
		high: 61.296,
		low: 40.072
	},
	"2025-03-12": {
		high: 60.372,
		low: 39.288
	},
	"2025-03-13": {
		high: 59.94,
		low: 39.28
	},
	"2025-03-14": {
		high: 60.204,
		low: 39.544
	},
	"2025-03-17": {
		high: 60.744,
		low: 39.936
	},
	"2025-03-18": {
		high: 61.26,
		low: 40.192
	},
	"2025-03-19": {
		high: 60.816,
		low: 39.008
	},
	"2025-03-20": {
		high: 58.392,
		low: 37.144
	},
	"2025-03-21": {
		high: 56.652,
		low: 36.416
	},
	"2025-03-24": {
		high: 51.552,
		low: 31.784
	},
	"2025-03-25": {
		high: 46.5,
		low: 30.072
	},
	"2025-03-26": {
		high: 45.912,
		low: 30.08
	},
	"2025-03-27": {
		high: 46.872,
		low: 30.104
	},
	"2025-03-28": {
		high: 47.472,
		low: 30.8
	},
	"2025-03-31": {
		high: 47.112,
		low: 30.32
	},
	"2025-04-01": {
		high: 45.432,
		low: 29.296
	},
	"2025-04-02": {
		high: 44.328,
		low: 28.736
	},
	"2025-04-03": {
		high: 45.744,
		low: 28.984
	},
	"2025-04-04": {
		high: 43.548,
		low: 27.384
	},
	"2025-04-07": {
		high: 41.844,
		low: 25.488
	},
	"2025-04-08": {
		high: 41.778,
		low: 26.632
	},
	"2025-04-09": {
		high: 39.996,
		low: 25.712
	},
	"2025-04-10": {
		high: 43.5,
		low: 27.864
	},
	"2025-04-11": {
		high: 41.94,
		low: 27.088
	},
	"2025-04-14": {
		high: 43.08,
		low: 28.12
	},
	"2025-04-15": {
		high: 42.492,
		low: 27.76
	},
	"2025-04-16": {
		high: 41.184,
		low: 27.144
	},
	"2025-04-17": {
		high: 41.964,
		low: 27.056
	},
	"2025-04-22": {
		high: 41.28,
		low: 27.064
	},
	"2025-04-23": {
		high: 43.068,
		low: 27.936
	},
	"2025-04-24": {
		high: 44.34,
		low: 28.768
	},
	"2025-04-28": {
		high: 45.78,
		low: 29.232
	},
	"2025-04-29": {
		high: 44.502,
		low: 29.152
	},
	"2025-04-30": {
		high: 44.652,
		low: 29.376
	},
	"2025-05-01": {
		high: 44.688,
		low: 29.48
	},
	"2025-05-02": {
		high: 45.9,
		low: 29.896
	},
	"2025-05-05": {
		high: 45.9,
		low: 29.728
	},
	"2025-05-06": {
		high: 45.048,
		low: 29.632
	},
	"2025-05-07": {
		high: 45,
		low: 29.488
	},
	"2025-05-08": {
		high: 44.604,
		low: 28.84
	},
	"2025-05-09": {
		high: 45.828,
		low: 29.76
	},
	"2025-05-12": {
		high: 46.86,
		low: 30.608
	},
	"2025-05-13": {
		high: 48.408,
		low: 31.264
	},
	"2025-05-14": {
		high: 48.24,
		low: 31.488
	},
	"2025-05-15": {
		high: 47.976,
		low: 31.144
	},
	"2025-05-16": {
		high: 47.124,
		low: 30.64
	},
	"2025-05-19": {
		high: 46.632,
		low: 30.336
	},
	"2025-05-20": {
		high: 46.656,
		low: 30.544
	},
	"2025-05-21": {
		high: 44.28,
		low: 28.24
	},
	"2025-05-22": {
		high: 44.1,
		low: 28.76
	},
	"2025-05-23": {
		high: 44.496,
		low: 29.04
	},
	"2025-05-26": {
		high: 43.056,
		low: 28.296
	},
	"2025-05-27": {
		high: 43.08,
		low: 28.152
	},
	"2025-05-28": {
		high: 42.912,
		low: 27.684
	},
	"2025-05-29": {
		high: 41.628,
		low: 27.28
	},
	"2025-05-30": {
		high: 42.9,
		low: 28.04
	},
	"2025-06-02": {
		high: 44.184,
		low: 28.752
	},
	"2025-06-03": {
		high: 44.34,
		low: 28.56
	},
	"2025-06-04": {
		high: 46.47,
		low: 30.304
	},
	"2025-06-05": {
		high: 47.604,
		low: 31.192
	},
	"2025-06-06": {
		high: 48.96,
		low: 31.944
	},
	"2025-06-10": {
		high: 50.064,
		low: 32.728
	},
	"2025-06-11": {
		high: 50.712,
		low: 32.96
	},
	"2025-06-12": {
		high: 49.98,
		low: 32.464
	},
	"2025-06-13": {
		high: 49.428,
		low: 31.928
	},
	"2025-06-16": {
		high: 48.72,
		low: 31.936
	},
	"2025-06-17": {
		high: 47.532,
		low: 30.892
	},
	"2025-06-18": {
		high: 46.476,
		low: 29.88
	},
	"2025-06-19": {
		high: 45.132,
		low: 29.688
	},
	"2025-06-20": {
		high: 45.108,
		low: 29.468
	},
	"2025-06-23": {
		high: 44.688,
		low: 29.36
	},
	"2025-06-24": {
		high: 46.032,
		low: 30.072
	},
	"2025-06-25": {
		high: 47.268,
		low: 30.496
	},
	"2025-06-26": {
		high: 47.19,
		low: 30.856
	},
	"2025-06-27": {
		high: 47.58,
		low: 30.936
	},
	"2025-06-30": {
		high: 51.372,
		low: 32.88
	},
	"2025-07-01": {
		high: 49.944,
		low: 32.416
	},
	"2025-07-02": {
		high: 53.592,
		low: 33.896
	},
	"2025-07-03": {
		high: 52.344,
		low: 33.96
	},
	"2025-07-04": {
		high: 52.38,
		low: 33.976
	},
	"2025-07-07": {
		high: 52.488,
		low: 34.248
	},
	"2025-07-08": {
		high: 52.296,
		low: 34.128
	},
	"2025-07-09": {
		high: 51.708,
		low: 33.52
	},
	"2025-07-10": {
		high: 51.42,
		low: 33.824
	},
	"2025-07-11": {
		high: 51.876,
		low: 33.856
	},
	"2025-07-14": {
		high: 50.592,
		low: 33
	},
	"2025-07-15": {
		high: 49.65,
		low: 32.656
	},
	"2025-07-16": {
		high: 48.528,
		low: 31.744
	},
	"2025-07-17": {
		high: 49.2,
		low: 31.928
	},
	"2025-07-18": {
		high: 49.464,
		low: 32.512
	},
	"2025-07-21": {
		high: 48.9,
		low: 32.256
	},
	"2025-07-22": {
		high: 48.54,
		low: 31.696
	},
	"2025-07-23": {
		high: 50.316,
		low: 32.832
	},
	"2025-07-24": {
		high: 50.844,
		low: 33.296
	},
	"2025-07-25": {
		high: 49.98,
		low: 32.8
	},
	"2025-07-28": {
		high: 50.016,
		low: 32.904
	},
	"2025-07-29": {
		high: 50.202,
		low: 32.952
	},
	"2025-07-30": {
		high: 51.06,
		low: 33.24
	},
	"2025-07-31": {
		high: 49.8,
		low: 32.904
	},
	"2025-08-01": {
		high: 48.696,
		low: 32
	},
	"2025-08-04": {
		high: 48.876,
		low: 31.948
	},
	"2025-08-05": {
		high: 49.644,
		low: 32.512
	},
	"2025-08-06": {
		high: 52.164,
		low: 33.6
	},
	"2025-08-07": {
		high: 51.564,
		low: 33.888
	},
	"2025-08-08": {
		high: 51.756,
		low: 34.104
	},
	"2025-08-11": {
		high: 52.584,
		low: 34.472
	},
	"2025-08-12": {
		high: 52.08,
		low: 34.176
	},
	"2025-08-13": {
		high: 53.142,
		low: 34.936
	},
	"2025-08-14": {
		high: 54.936,
		low: 35.88
	},
	"2025-08-15": {
		high: 55.176,
		low: 36.136
	},
	"2025-08-18": {
		high: 54.624,
		low: 35.52
	},
	"2025-08-19": {
		high: 53.796,
		low: 35.36
	},
	"2025-08-20": {
		high: 39.84,
		low: 24.856
	},
	"2025-08-21": {
		high: 36.192,
		low: 22.488
	},
	"2025-08-22": {
		high: 37.032,
		low: 24.128
	},
	"2025-08-25": {
		high: 38.256,
		low: 24.92
	},
	"2025-08-26": {
		high: 36.96,
		low: 23.816
	},
	"2025-08-27": {
		high: 37.464,
		low: 24.188
	},
	"2025-08-28": {
		high: 37.656,
		low: 24.616
	},
	"2025-08-29": {
		high: 38.04,
		low: 24.936
	},
	"2025-09-01": {
		high: 37.2,
		low: 24.088
	},
	"2025-09-02": {
		high: 36.78,
		low: 23.808
	},
	"2025-09-03": {
		high: 36.144,
		low: 23.792
	},
	"2025-09-04": {
		high: 35.7,
		low: 23.448
	},
	"2025-09-05": {
		high: 36.336,
		low: 23.824
	},
	"2025-09-08": {
		high: 37.392,
		low: 24.656
	},
	"2025-09-09": {
		high: 36.48,
		low: 23.8
	},
	"2025-09-10": {
		high: 35.784,
		low: 23.464
	},
	"2025-09-11": {
		high: 35.82,
		low: 23.608
	},
	"2025-09-12": {
		high: 37.032,
		low: 24.016
	},
	"2025-09-15": {
		high: 36.288,
		low: 23.872
	},
	"2025-09-16": {
		high: 36.204,
		low: 23.768
	},
	"2025-09-17": {
		high: 35.688,
		low: 23.544
	},
	"2025-09-18": {
		high: 35.16,
		low: 22.744
	},
	"2025-09-19": {
		high: 35.64,
		low: 23.048
	},
	"2025-09-22": {
		high: 35.628,
		low: 23.328
	},
	"2025-09-23": {
		high: 35.76,
		low: 23.44
	},
	"2025-09-24": {
		high: 34.8,
		low: 22.408
	},
	"2025-09-25": {
		high: 33.48,
		low: 21.856
	},
	"2025-09-26": {
		high: 34.128,
		low: 22.32
	},
	"2025-09-29": {
		high: 34.446,
		low: 22.68
	},
	"2025-09-30": {
		high: 34.284,
		low: 22.416
	},
	"2025-10-01": {
		high: 35.052,
		low: 22.944
	},
	"2025-10-02": {
		high: 35.664,
		low: 23.536
	},
	"2025-10-03": {
		high: 36.288,
		low: 23.72
	},
	"2025-10-06": {
		high: 37.656,
		low: 24.448
	},
	"2025-10-07": {
		high: 36.78,
		low: 24.192
	},
	"2025-10-08": {
		high: 40.14,
		low: 26
	},
	"2025-10-09": {
		high: 40.44,
		low: 26.104
	},
	"2025-10-10": {
		high: 40.032,
		low: 26.116
	},
	"2025-10-13": {
		high: 39.588,
		low: 26.024
	},
	"2025-10-14": {
		high: 39.48,
		low: 25.672
	},
	"2025-10-15": {
		high: 41.364,
		low: 27.152
	},
	"2025-10-16": {
		high: 41.664,
		low: 27.184
	},
	"2025-10-17": {
		high: 40.38,
		low: 26.416
	},
	"2025-10-20": {
		high: 40.176,
		low: 26.4
	},
	"2025-10-21": {
		high: 39.96,
		low: 26.296
	},
	"2025-10-22": {
		high: 40.428,
		low: 26.408
	},
	"2025-10-23": {
		high: 40.212,
		low: 26.344
	},
	"2025-10-24": {
		high: 41.172,
		low: 26.872
	},
	"2025-10-27": {
		high: 41.76,
		low: 27.32
	},
	"2025-10-28": {
		high: 42.288,
		low: 27.056
	},
	"2025-10-29": {
		high: 41.1,
		low: 26.88
	},
	"2025-10-30": {
		high: 39.552,
		low: 25.824
	},
	"2025-10-31": {
		high: 39.252,
		low: 25.72
	},
	"2025-11-03": {
		high: 38.652,
		low: 25.288
	},
	"2025-11-04": {
		high: 37.8,
		low: 24.376
	},
	"2025-11-05": {
		high: 35.76,
		low: 22.88
	},
	"2025-11-06": {
		high: 32.136,
		low: 19.528
	},
	"2025-11-07": {
		high: 32.4,
		low: 20.72
	},
	"2025-11-10": {
		high: 32.22,
		low: 20.8
	},
	"2025-11-11": {
		high: 31.764,
		low: 20.688
	},
	"2025-11-12": {
		high: 31.482,
		low: 20.488
	},
	"2025-11-13": {
		high: 31.596,
		low: 20.328
	},
	"2025-11-14": {
		high: 30.948,
		low: 20.12
	},
	"2025-11-17": {
		high: 31.344,
		low: 20.152
	},
	"2025-11-18": {
		high: 33.654,
		low: 21.312
	},
	"2025-11-19": {
		high: 33.24,
		low: 21.512
	},
	"2025-11-20": {
		high: 34.284,
		low: 22.04
	},
	"2025-11-21": {
		high: 33.684,
		low: 21.808
	},
	"2025-11-24": {
		high: 35.196,
		low: 22.088
	},
	"2025-11-25": {
		high: 34.98,
		low: 22.448
	},
	"2025-11-26": {
		high: 36.66,
		low: 23.552
	},
	"2025-11-27": {
		high: 36.276,
		low: 23.832
	},
	"2025-11-28": {
		high: 36.672,
		low: 23.952
	},
	"2025-12-01": {
		high: 36.348,
		low: 23.8
	},
	"2025-12-02": {
		high: 36,
		low: 23.564
	},
	"2025-12-03": {
		high: 35.868,
		low: 23.456
	},
	"2025-12-04": {
		high: 36.576,
		low: 23.736
	},
	"2025-12-05": {
		high: 36.006,
		low: 23.44
	},
	"2025-12-08": {
		high: 35.988,
		low: 23.472
	},
	"2025-12-09": {
		high: 35.028,
		low: 22.776
	},
	"2025-12-10": {
		high: 34.608,
		low: 22.568
	},
	"2025-12-11": {
		high: 36.774,
		low: 23.68
	},
	"2025-12-12": {
		high: 36.648,
		low: 24.04
	},
	"2025-12-15": {
		high: 37.2,
		low: 24.44
	},
	"2025-12-16": {
		high: 36.834,
		low: 24.056
	},
	"2025-12-17": {
		high: 36.66,
		low: 24.064
	},
	"2025-12-18": {
		high: 36.36,
		low: 23.832
	},
	"2025-12-19": {
		high: 37.068,
		low: 24.096
	},
	"2025-12-22": {
		high: 37.188,
		low: 24.4
	},
	"2025-12-23": {
		high: 37.596,
		low: 24.624
	},
	"2025-12-24": {
		high: 37.104,
		low: 24.44
	},
	"2025-12-29": {
		high: 37.524,
		low: 24.76
	},
	"2025-12-30": {
		high: 38.1,
		low: 24.832
	},
	"2025-12-31": {
		high: 37.308,
		low: 24.608
	},
	"2026-01-02": {
		high: 37.74,
		low: 24.576
	},
	"2026-01-05": {
		high: 37.416,
		low: 24.488
	},
	"2026-01-06": {
		high: 38.118,
		low: 24.816
	},
	"2026-01-07": {
		high: 38.352,
		low: 25.192
	},
	"2026-01-08": {
		high: 37.188,
		low: 24.128
	},
	"2026-01-09": {
		high: 38.916,
		low: 25.448
	},
	"2026-01-12": {
		high: 41.94,
		low: 27.184
	},
	"2026-01-13": {
		high: 41.808,
		low: 27.52
	},
	"2026-01-14": {
		high: 41.688,
		low: 27.56
	},
	"2026-01-15": {
		high: 42.012,
		low: 27.752
	},
	"2026-01-16": {
		high: 43.164,
		low: 28.416
	},
	"2026-01-19": {
		high: 42.816,
		low: 27.24
	},
	"2026-01-20": {
		high: 42.048,
		low: 26.84
	},
	"2026-01-21": {
		high: 41.904,
		low: 27.504
	},
	"2026-01-22": {
		high: 42.72,
		low: 28.048
	},
	"2026-01-23": {
		high: 43.536,
		low: 28.496
	},
	"2026-01-27": {
		high: 42.396,
		low: 27.44
	},
	"2026-01-28": {
		high: 41.52,
		low: 27.008
	},
	"2026-01-29": {
		high: 40.74,
		low: 26.664
	},
	"2026-01-30": {
		high: 40.8,
		low: 26.448
	},
	"2026-02-02": {
		high: 39.576,
		low: 25.944
	},
	"2026-02-03": {
		high: 39.96,
		low: 26.264
	},
	"2026-02-04": {
		high: 40.62,
		low: 26.416
	},
	"2026-02-05": {
		high: 40.776,
		low: 26.756
	},
	"2026-02-06": {
		high: 39.936,
		low: 25.76
	},
	"2026-02-09": {
		high: 40.512,
		low: 26.624
	},
	"2026-02-10": {
		high: 39.888,
		low: 26.296
	},
	"2026-02-11": {
		high: 45.468,
		low: 27.8
	},
	"2026-02-12": {
		high: 45.168,
		low: 29.368
	},
	"2026-02-13": {
		high: 44.52,
		low: 29.152
	},
	"2026-02-16": {
		high: 44.256,
		low: 28.944
	},
	"2026-02-17": {
		high: 43.692,
		low: 28.744
	},
	"2026-02-18": {
		high: 43.26,
		low: 28.328
	},
	"2026-02-19": {
		high: 43.152,
		low: 28.216
	},
	"2026-02-20": {
		high: 42.468,
		low: 27.728
	},
	"2026-02-23": {
		high: 42.42,
		low: 27.68
	},
	"2026-02-24": {
		high: 41.988,
		low: 27.448
	},
	"2026-02-25": {
		high: 43.212,
		low: 28.296
	},
	"2026-02-26": {
		high: 42.132,
		low: 27.52
	},
	"2026-02-27": {
		high: 41.976,
		low: 27.376
	},
	"2026-03-02": {
		high: 40.836,
		low: 26.824
	},
	"2026-03-03": {
		high: 40.332,
		low: 26.04
	},
	"2026-03-04": {
		high: 39,
		low: 24.832
	},
	"2026-03-05": {
		high: 37.896,
		low: 25.008
	},
	"2026-03-06": {
		high: 37.956,
		low: 24.824
	},
	"2026-03-09": {
		high: 35.928,
		low: 23.032
	},
	"2026-03-10": {
		high: 36.36,
		low: 23.776
	},
	"2026-03-11": {
		high: 35.436,
		low: 23.376
	},
	"2026-03-12": {
		high: 34.788,
		low: 22.76
	},
	"2026-03-13": {
		high: 34.008,
		low: 22.28
	},
	"2026-03-16": {
		high: 34.068,
		low: 22.248
	},
	"2026-03-17": {
		high: 34.116,
		low: 22.2
	},
	"2026-03-18": {
		high: 34.92,
		low: 22.688
	},
	"2026-03-19": {
		high: 34.212,
		low: 22.552
	},
	"2026-03-20": {
		high: 33.3,
		low: 21.936
	},
	"2026-03-23": {
		high: 32.808,
		low: 21.216
	},
	"2026-03-24": {
		high: 34.02,
		low: 22.08
	},
	"2026-03-25": {
		high: 34.392,
		low: 22.472
	},
	"2026-03-26": {
		high: 34.164,
		low: 22.224
	},
	"2026-03-27": {
		high: 32.82,
		low: 21.504
	},
	"2026-03-30": {
		high: 31.62,
		low: 20.712
	},
	"2026-03-31": {
		high: 31.464,
		low: 20.296
	},
	"2026-04-01": {
		high: 33.768,
		low: 21.952
	},
	"2026-04-02": {
		high: 33.756,
		low: 21.768
	},
	"2026-04-07": {
		high: 33.552,
		low: 21.776
	},
	"2026-04-08": {
		high: 35.496,
		low: 22.728
	},
	"2026-04-09": {
		high: 34.872,
		low: 22.912
	},
	"2026-04-10": {
		high: 35.292,
		low: 23.08
	},
	"2026-04-13": {
		high: 35.136,
		low: 22.928
	},
	"2026-04-14": {
		high: 35.808,
		low: 23.432
	},
	"2026-04-15": {
		high: 35.616,
		low: 23.4
	},
	"2026-04-16": {
		high: 33.84,
		low: 22.168
	},
	"2026-04-17": {
		high: 33.972,
		low: 22.344
	},
	"2026-04-20": {
		high: 36.024,
		low: 23.328
	},
	"2026-04-21": {
		high: 36.792,
		low: 24.256
	},
	"2026-04-22": {
		high: 37.212,
		low: 24.56
	},
	"2026-04-23": {
		high: 37.044,
		low: 24.196
	},
	"2026-04-24": {
		high: 37.548,
		low: 24.648
	},
	"2026-04-27": {
		high: 36.984,
		low: 24.336
	},
	"2026-04-28": {
		high: 37.224,
		low: 24.472
	},
	"2026-04-29": {
		high: 36.768,
		low: 24.192
	},
	"2026-04-30": {
		high: 35.208,
		low: 22.832
	},
	"2026-05-01": {
		high: 35.328,
		low: 23.184
	},
	"2026-05-04": {
		high: 35.064,
		low: 22.928
	},
	"2026-05-05": {
		high: 33.6,
		low: 21.944
	},
	"2026-05-06": {
		high: 33.852,
		low: 22.352
	},
	"2026-05-07": {
		high: 35.544,
		low: 23.232
	},
	"2026-05-08": {
		high: 34.464,
		low: 22.504
	},
	"2026-05-11": {
		high: 34.8,
		low: 22.888
	},
	"2026-05-12": {
		high: 33.876,
		low: 22.352
	},
	"2026-05-13": {
		high: 33.732,
		low: 22.16
	},
	"2026-05-14": {
		high: 33.156,
		low: 21.624
	},
	"2026-05-15": {
		high: 33.06,
		low: 21.528
	},
	"2026-05-18": {
		high: 32.484,
		low: 20.64
	},
	"2026-05-19": {
		high: 32.796,
		low: 21.4
	}
};
